module.exports = __webpack_public_path__ + "img/05813363001565.1ba0ed10.png";